import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppleLogo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M14.4297 10.707C14.4297 10.7773 14.3242 12.8516 16.6094 13.9414C16.1875 15.2422 14.7109 18.125 12.9883 18.125C12.0039 18.125 11.4414 17.4922 10.3164 17.4922C9.15625 17.4922 8.52344 18.125 7.64453 18.125C5.95703 18.1953 4.33984 15.0312 3.88281 13.7305C3.53125 12.7461 3.39063 11.7969 3.39063 10.8828C3.39063 7.75391 5.46484 6.24219 7.43359 6.20703C8.38281 6.20703 9.57812 6.875 10.1055 6.875C10.5977 6.875 11.9688 6.06641 13.2344 6.17187C14.5352 6.27734 15.5195 6.76953 16.1875 7.71875C15.0273 8.45703 14.4297 9.40625 14.4297 10.707ZM12.4609 4.94141C11.7578 5.75 10.9141 6.20703 10 6.13672C9.92969 5.1875 10.2812 4.30859 10.9141 3.60547C11.4766 2.97266 12.4609 2.44531 13.3047 2.375C13.3047 2.76172 13.4102 3.81641 12.4609 4.94141Z"
	})
});
const ForwardRef = forwardRef(SvgAppleLogo);
export default ForwardRef;
